import { KeyValuePair } from '@app/core/models/keyValuePair';

class PlinthTypes {
  Begin = { key: 1, value: 'Begin' };
  End = { key: 2, value: 'Eind' };
  Between = { key: 3, value: 'Tussen' };
}
const plinthTypes = new PlinthTypes();
const keyValuePairs: KeyValuePair[] = [
  plinthTypes.Begin,
  plinthTypes.End,
  plinthTypes.Between,
];

export  {
    plinthTypes,
    keyValuePairs
}
